import React, { useContext } from 'react';
import menuItemsProps from '../interfaces/MenuItemProps';
import StyledContainer from './StyledContainer';
import StyledTitle from './StyledTitle';
import StylesContext from '../context/StylesContext';

type itemProps = Pick<menuItemsProps, 'item_name' | 'price'>;

const ItemsList: React.FC<itemProps> = ({item_name, price}) => {
  const { styles } = useContext(StylesContext);
  return (
    <>      
      <StyledContainer $bgColor={styles.bgCategoryContainer} className='item_card'>
        <StyledTitle $textColor={styles.textColor} className='item-list-text'>
          {`${item_name} - R$ ${price} `}
        </StyledTitle>
      </StyledContainer>
    </>
  )
}

export default ItemsList;